module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.voteAuth) ? _vm._t("voteMain") : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-7d439354!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/vote/Base.vue
// module id = Ib0l
// module chunks = 4